import store from 'configureStore';

export const setIncidentsTypes = () => store.getState().adas.incidentsTypes || {};